$shm_hitalama_map_widget_float_settings_chart $shm_hitalama_map_widget_float_settings
	controls /
		<= Settings_scroll
	controlled_settings_content /
		<= Axis_field $mol_form_field
			name \Ось
			Content <= Axis_content $mol_view
				sub /
					<= Axis $mol_select
						Filter null
						options <= table_head /
						value? <=> axis? \
					^ axis_details_visible / <= Axis_details $mol_select
						Filter null
						dictionary *
							day \День
							month \Месяц
							year \Год
						value? <=> axis_details? \day
		<= Values_field $mol_form_field
			name \Значения
			Content <= Values $mol_select
				Filter null
				options <= table_head /
				value? <=> values_title? \
		<= Groups_field $mol_form_field
			name \Группировка
			Content <= Groups $mol_select_list
				value? <=> groups? /
				options <= table_head /
